import { render, staticRenderFns } from "./SmallGroupHeading.vue?vue&type=template&id=7b1613ff&scoped=true&"
import script from "./SmallGroupHeading.vue?vue&type=script&lang=js&"
export * from "./SmallGroupHeading.vue?vue&type=script&lang=js&"
import style0 from "./SmallGroupHeading.vue?vue&type=style&index=0&id=7b1613ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1613ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
